import axios from 'axios';

import { UseQueryResult, useQuery, useQueryClient } from '@tanstack/react-query';
import { BitcoinData } from '@/app/_page/vault-activity/vault-chart/vault-chart';

import { QueryKeys } from './query-keys';
import { Interval } from './api.types';
import { get } from './api.helpers';

export interface HistoryPriceResponse {
  history: BitcoinData[];
  change: string;
}

export interface UseHistoryPriceParams {
  interval: Interval;
}

// todo: switch to price oracle
// https://test-price.ducatprotocol.com/api/price/history?start=1748799868&res=1m

export const useHistoryPrice = ({ interval }: UseHistoryPriceParams): UseQueryResult<HistoryPriceResponse> => {
  const queryClient = useQueryClient();
  const path = `/api/price-history?timePeriod=${interval}`;

  return useQuery<HistoryPriceResponse>({
    queryKey: [QueryKeys.historyPrice, interval],
    queryFn: async () => {
      try {
        const result = await get<{data: HistoryPriceResponse} | { error: string }>(path);
        console.log(`[useHistoryPrice]`, result);
        if ((result as { error: string }).error) {
          throw new Error((result as { error: string }).error);
        }
        return (result as {data: HistoryPriceResponse}).data;
      } catch (e) {
        // Store 1y (which never fails) as a fallback for UI:
        const data1y = queryClient.getQueryData<HistoryPriceResponse>([QueryKeys.historyPrice, '1y']);
        queryClient.setQueryData([QueryKeys.historyPrice, interval], data1y);
        // Still throw the error to trigger retries
        throw e;
      }
    },
    // For 24h interval invalidate cache after 1 hour.
    staleTime: interval === '24h' ? 60 * 60 * 1000 : Infinity,
    retry: 5,
    retryDelay: 5000,
  });
};
